<template>
  <div class="visa-news-item" @click="goArticleDetail(newsInfo.id)">
    <div class="left-info">
      <div class="news-title">{{ newsInfo.title }}</div>
      <div class="news-desc">{{ newsInfo.summary }}</div>
      <div class="bottom-info">
        <img src="../../../assets/imgs/acadmy/view.png" class="viewed">
        <span class="view-count">{{ formatViewecCount(newsInfo.hit) }}</span>
        <img src="../../../assets/imgs/acadmy/time.png" class="time">
        <span class="time-text" v-if="newsInfo.update_time">{{ newsInfo.update_time.substring(0, 10) }}</span>
      </div>
    </div>
    <img class="news-img" :src="newsInfo.cover" />
  </div>
</template>

<script>
import knowledgeService from "../../../services/knowledge-service";

export default {
  name: 'visa-news-item',
  props: {
    newsInfo: {
      type: Object,
      required: true,
      default() {
        return {};
      }
    }
  },
  methods: {
    formatViewecCount:knowledgeService.formatViewecCount,
    goArticleDetail(id) {
      this.$router.push({ name: 'article', params: { id } })
    }
  }
}
</script>

<style lang="less" scoped>

.visa-news-item {
  padding: 20px 0;
  border-bottom: 1px solid #E9EEF2;
  display: flex;
  align-items: center;
  cursor: pointer;
  .left-info {
    display: flex;
    flex-direction: column;
    flex: 1;
    .news-title {
      margin-top: 16px;
      font-size: 20px;
      font-weight: 600;
      color: #2F333D;
      line-height: 28px;
    }
    .news-desc {
      margin-top: 12px;
      font-size: 16px;
      font-weight: 400;
      color: #5F666E;
      line-height: 26px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .bottom-info {
      margin-top: 21px;
      .viewed {
        width: 16px;
        height: 12px;
      }
      .view-count {
        font-size: 14px;
        line-height: 14px;
        font-weight: 400;
        color: #91999F;
      }
      .time {
        margin-left: 20px;
        width: 12px;
        height: 12px;
      }
      .time-text {
        font-size: 14px;
        font-weight: 400;
        color: #91999F;
        line-height: 14px;
        margin-left: 2px;
      }
    }
  }
  .news-img {
    flex-shrink: 0;
    width: 220px;
    height: 148px;
    margin-left: 60px;
  }
  &:hover {
    .left-info {
      .news-title {
        color: #599FFF;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/academy/components/visa-news-item.vue